import React from 'react';
import { resetFightMechanic } from '../../../controllers/fightController';
import { allies } from '../../../mechanics/AllyMechanic';
import { soundToPlay, soundToStop } from '../../../mechanics/sounds/sound';
import { sceneSlice } from '../../../store/reducers/SceneReducer';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import './FightScenIsDead.scss'

const FightScenIsDead = () => {
    const dispatch = useAppDispatch()
    const { setScene, resetPassedLocationLevels } = sceneSlice.actions
    const locations = useAppSelector(state => state.SceneReducer.locations)

    React.useEffect(() => {
        soundToPlay("death")
        soundToStop("fightMusic")
        soundToStop("bossMusic")
    },[])

    function exitFightScene() {
        allies.forEach((item) => {
            item.resetLevel()
        })
        locations.resetLocations()
        dispatch(resetPassedLocationLevels(0))
        resetFightMechanic()
        dispatch(setScene("create"))
        soundToPlay("mainMusic")
    }

    return (
        <div className='character-is-dead' onClick={() => exitFightScene()}>
            <p>You died</p>
        </div>
    );
};

export default FightScenIsDead;